import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Appendices`}</h2>
    <p>{`This page gives access to items that should help understand the figures and animations on this site and assist those who wish to implement the rotation models on their own plate-reconstruction software. `}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../legend-to-the-anims"
        }}>{`Legend to the animations:`}</a>{` Explanation of the colours used in the figures and animations`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../latest-rotation"
        }}>{`Recent rotation poles:`}</a>{` Euler rotation parameters for the most recent reconstruction model`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/reevesdotnl/2115141cd45a1d6ee9b93af40f559ae3/finite-rotations.pdf"
        }}>{`Finite Euler rotation poles for Gondwana reassembly:`}</a>{` Updated 2025 September 29`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.reeves.nl/upload/Course-Notes-Rio-2015.pdf"
        }}>{`Course Notes, Rio de Janiero 2015:`}</a>{` Notes for a course of 12 lectures entitled `}<em parentName="li">{`African Geodynamics`}</em>{`.`}</li>
    </ul>
    <p>{`See Publications page (Gondwana publications) for recent posters and presentations.`}</p>
    <p>{`Queries?  `}<a parentName="p" {...{
        "href": "../../contact"
      }}>{`Please get in touch`}</a></p>
    <p><em parentName="p">{`Last update: 2025 September 29`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../gondwana"
        }}>{`Return to Gondwana main page`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      